import { createActionType, createAction, createApiCallAction } from '@ers/helpers';

const prefix = 'Form';
export const ActionTypes = {
    fetchApplicationDetails: createActionType('fetchApplicationDetails')(prefix),
    fetchApplicationDetailsCompleted: createActionType('fetchApplicationDetailsCompleted')(prefix)
};

export const fetchApplicationDetails = (applicationId) => createApiCallAction(ActionTypes.fetchApplicationDetails)({ payload: { applicationId } });
export const fetchApplicationDetailsCompleted = (applicationId, form) => createAction(ActionTypes.fetchApplicationDetailsCompleted)({ payload: { applicationId, form } });
